import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const MicOffOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M7.24 14.61a4.96 4.96 0 0 1-.75-2.6c0-.44-.36-.8-.8-.8-.44 0-.8.36-.8.8 0 1.39.44 2.68 1.19 3.75l1.15-1.15h.01ZM9.27 12.58c-.13-.33-.21-.69-.21-1.07V6.47c0-1.62 1.32-2.94 2.94-2.94 1.62 0 2.94 1.32 2.94 2.94v.44l1.47-1.47c-.47-2.01-2.26-3.51-4.41-3.51a4.55 4.55 0 0 0-4.54 4.54v5.03c0 .83.24 1.59.62 2.26l1.18-1.18h.01ZM12 16.05c2.5 0 4.54-2.04 4.54-4.54V8.59l3.4-3.4a.79.79 0 0 0 0-1.12.79.79 0 0 0-1.12 0L4.19 18.7a.79.79 0 0 0 .56 1.35c.2 0 .4-.08.56-.23l2.41-2.41c.99.72 2.18 1.22 3.48 1.36v2.45c0 .44.36.8.8.8.44 0 .8-.36.8-.8v-2.45c3.54-.38 6.31-3.26 6.31-6.75 0-.44-.36-.8-.8-.8-.44 0-.8.36-.8.8 0 2.87-2.47 5.2-5.51 5.2a5.64 5.64 0 0 1-3.13-.95l.85-.85c.67.4 1.44.64 2.28.64v-.01Zm2.94-4.54c0 1.62-1.32 2.94-2.94 2.94-.39 0-.75-.09-1.09-.23l4.03-4.03v1.32Z"
      fill={color}
    />
  </Svg>
)

export default MicOffOutlined
